exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PolicyPage.scss?vue&type=style&index=0&id=a11faf02&prod&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
